export default "__VITE_ASSET__DZ64lpQN__"